import { defineMessages } from "react-intl";

export const searchParamErrorPageMessages = defineMessages({
  invalidFormat: {
    id: "search-param-error.title",
    defaultMessage: "Неверный формат данных!",
  },
  urlErrors: {
    id: "search-param-error.description",
    defaultMessage: "В параметрах URL содержатся ошибки:",
  },
});

export const errorPageMessages = defineMessages({
  description: {
    id: "error-page.description",
    defaultMessage: "Please try again later.",
  },
  retryButton: {
    id: "error-page.retry-button",
    defaultMessage: "Retry",
  },
  title: {
    id: "error-page.title",
    defaultMessage: "Something went wrong.",
  },
});
